export default __webpack_public_path__ + "static/media/BadgerLogoandAddress.2afa229c.png";